import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  AUTH_STATUS_NEW,
  REQUEST_INVOICE_CODE_FIELD,
} from "constants/FormatDataContanst";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import {
  generateDateField,
  generateDateFieldObject,
  generateInputField,
  generateInputFieldObject,
} from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createRequestInvoiceCode,
  downloadXmlRequestInvoiceCode,
  editRequestInvoiceCode,
  getDetailRequestInvoiceCode,
} from "store/actions";
import * as yup from "yup";
import "../detailData.scss";
import {
  convertDate,
  formatTimestampToDate,
  initOptionDateLocale,
  MODE_FORM,
} from "../utils";
const DetailData = props => {
  const { isOpen, toggle, dataDetail, t, i18n, toggleReleaseModal } = props;
  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });
  const modal = useRef(null);
  const [disableForm, setDisableForm] = useState(false);
  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  const dispatch = useDispatch();
  // store reducer

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    loading: loadingDetail,
    data: detailRequestInvoiceCode,
    error,
  } = dataFormat.detailRequestInvoiceCode;

  const { loading: loadingSubmitCreate, error: errorSubmitCreate } =
    dataFormat.createRequestInvoiceCode;
  const { loading: loadingSubmitEdit, error: errorSubmitEdit } =
    dataFormat.editRequestInvoiceCode;

  useEffect(() => {
    return () => {};
  }, []);

  const COMMON_FIELD = REQUEST_INVOICE_CODE_FIELD.COMMON;
  const REQUEST_CONTENT_OBJ_FIELD =
    REQUEST_INVOICE_CODE_FIELD.REQUEST_CONTENT_OBJ;

  useEffect(() => {
    if (isOpen) {
      checkDisableForm();
      reset();
      if (dataDetail?.id) {
        dispatch(getDetailRequestInvoiceCode(dataDetail.id));
      }
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
          setFocus(COMMON_FIELD.TCQT.field);
        }
      });
    }
  }, [isOpen]);

  const checkDisableForm = () => {
    if (dataDetail?.mode === MODE_FORM.VIEW) {
      setDisableForm(true);
    } else {
      setDisableForm(false);
    }
  };

  useEffect(() => {
    if (detailRequestInvoiceCode) {
      // Set default value COMMON_FIELD
      setDefaultValue(COMMON_FIELD);
      setDefaultObjectValue(REQUEST_CONTENT_OBJ_FIELD);
    }
  }, [detailRequestInvoiceCode]);

  // Custom set default value
  const setDefaultValue = FIELDS => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      const finalValue = detailRequestInvoiceCode[finalKey];
      if (finalValue) {
        switch (type) {
          case "text":
            setValue(finalKey, finalValue);
            break;
          case "date":
            const date = formatTimestampToDate(finalValue);
            setValue(finalKey, [date]);
            break;
        }
      }
    }
  };

  const setDefaultObjectValue = FIELDS => {
    const fieldObjectDetail = "requestContent";
    const fieldObjectForm = FIELDS.field;
    for (const key in FIELDS) {
      if (key !== "field") {
        const finalKey = FIELDS[key].field;
        const type = FIELDS[key].type;
        const finalValue =
          detailRequestInvoiceCode[fieldObjectDetail][finalKey];
        if (finalValue) {
          switch (type) {
            case "number":
              setValue(`${fieldObjectForm}.${finalKey}`, finalValue);
            case "text":
              setValue(`${fieldObjectForm}.${finalKey}`, finalValue);
              break;
            case "date":
              const date = formatTimestampToDate(finalValue);
              setValue(`${fieldObjectForm}.${finalKey}`, [date]);
              break;
          }
        }
      }
    }
  };

  const schema = yup.object().shape({
    // THông tin chung
    [COMMON_FIELD.PBAN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.PBAN.field}`),
        })
      )
      .max(
        COMMON_FIELD.PBAN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.PBAN.max })
      ),
    [COMMON_FIELD.MSO.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MSO.field}`),
        })
      )
      .max(
        COMMON_FIELD.MSO.max,
        t("form.validate.char_max", { max: COMMON_FIELD.MSO.max })
      ),
    [COMMON_FIELD.TEN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TEN.field}`),
        })
      )
      .max(
        COMMON_FIELD.TEN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TEN.max })
      ),
    [COMMON_FIELD.TCQT.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TCQT.field}`),
        })
      )
      .max(
        COMMON_FIELD.TCQT.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TCQT.max })
      ),
    [COMMON_FIELD.MCQT.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MCQT.field}`),
        })
      )
      .max(
        COMMON_FIELD.MCQT.max,
        t("form.validate.char_max", { max: COMMON_FIELD.MCQT.max })
      ),
    [COMMON_FIELD.TTCCNHAN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TTCCNHAN.field}`),
        })
      )
      .max(
        COMMON_FIELD.TTCCNHAN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TTCCNHAN.max })
      ),
    [COMMON_FIELD.DCLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DCLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.DCLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DCLHE.max })
      ),
    [COMMON_FIELD.DCTDTU.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
        })
      )
      .email(
        t("form.validate.invalid", {
          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
        })
      )
      .max(
        COMMON_FIELD.DCTDTU.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DCTDTU.max })
      ),
    [COMMON_FIELD.DTLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DTLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.DTLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DTLHE.max })
      ),
    [COMMON_FIELD.SQDTLAP.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.SQDTLAP.field}`),
        })
      )
      .max(
        COMMON_FIELD.SQDTLAP.max,
        t("form.validate.char_max", { max: COMMON_FIELD.SQDTLAP.max })
      ),
    [COMMON_FIELD.NCQDTLAP.field]: yup.array().min(
      1,
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.NCQDTLAP.field}`),
      })
    ),
    [COMMON_FIELD.CQCQDTLAP.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.CQCQDTLAP.field}`),
        })
      )
      .max(
        COMMON_FIELD.CQCQDTLAP.max,
        t("form.validate.char_max", { max: COMMON_FIELD.CQCQDTLAP.max })
      ),
    [COMMON_FIELD.MST.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MST.field}`),
        })
      )
      .test(
        "len",
        "Vui lòng nhập 10 hoặc 14 ký tự",
        val => val.length === 0 || val.length === 10 || val.length === 14
      ),
    [COMMON_FIELD.TNNHDON.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TNNHDON.field}`),
        })
      )
      .max(
        COMMON_FIELD.TNNHDON.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TNNHDON.max })
      ),
    [COMMON_FIELD.CMND.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.CMND.field}`),
        })
      )
      .max(
        COMMON_FIELD.CMND.max,
        t("form.validate.char_max", { max: COMMON_FIELD.CMND.max })
      ),
    [COMMON_FIELD.NGCCMND.field]: yup.array().min(
      1,
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.NGCCMND.field}`),
      })
    ),
    [COMMON_FIELD.NCCMND.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.NCCMND.field}`),
        })
      )
      .max(
        COMMON_FIELD.NCCMND.max,
        t("form.validate.char_max", { max: COMMON_FIELD.NCCMND.max })
      ),
    [COMMON_FIELD.DDANH.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DDANH.field}`),
        })
      )
      .max(
        COMMON_FIELD.DDANH.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DDANH.max })
      ),
    [COMMON_FIELD.NLAP.field]: yup.array().min(
      1,
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.NLAP.field}`),
      })
    ),
    // Nội dung đề nghị
    [REQUEST_CONTENT_OBJ_FIELD.field]: yup.object().shape({
      [REQUEST_CONTENT_OBJ_FIELD.THHDVU.field]: yup
        .string()
        .required(
          t("form.validate.required", {
            title: t(
              `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.THHDVU.field}`
            ),
          })
        )
        .max(
          REQUEST_CONTENT_OBJ_FIELD.THHDVU.max,
          t("form.validate.char_max", {
            max: REQUEST_CONTENT_OBJ_FIELD.THHDVU.max,
          })
        ),
      [REQUEST_CONTENT_OBJ_FIELD.TEN.field]: yup
        .string()
        .required(
          t("form.validate.required", {
            title: t(
              `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.TEN.field}`
            ),
          })
        )
        .max(
          REQUEST_CONTENT_OBJ_FIELD.TEN.max,
          t("form.validate.char_max", {
            max: REQUEST_CONTENT_OBJ_FIELD.TEN.max,
          })
        ),
      [REQUEST_CONTENT_OBJ_FIELD.DCHI.field]: yup
        .string()
        .required(
          t("form.validate.required", {
            title: t(
              `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.DCHI.field}`
            ),
          })
        )
        .max(
          REQUEST_CONTENT_OBJ_FIELD.DCHI.max,
          t("form.validate.char_max", {
            max: REQUEST_CONTENT_OBJ_FIELD.DCHI.max,
          })
        ),
      [REQUEST_CONTENT_OBJ_FIELD.MST.field]: yup
        .string()
        .required(
          t("form.validate.required", {
            title: t(
              `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.MST.field}`
            ),
          })
        )
        .test(
          "len",
          "Vui lòng nhập 10 hoặc 14 ký tự",
          val => val.length === 0 || val.length === 10 || val.length === 14
        ),
      [REQUEST_CONTENT_OBJ_FIELD.SHDONG.field]: yup
        .string()
        .required(
          t("form.validate.required", {
            title: t(
              `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.SHDONG.field}`
            ),
          })
        )
        .max(
          REQUEST_CONTENT_OBJ_FIELD.SHDONG.max,
          t("form.validate.char_max", {
            max: REQUEST_CONTENT_OBJ_FIELD.SHDONG.max,
          })
        ),
      [REQUEST_CONTENT_OBJ_FIELD.NHDONG.field]: yup.array().min(
        1,
        t("form.validate.select", {
          title: t(
            `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.NHDONG.field}`
          ),
        })
      ),
      [REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.field]: yup
        .string()
        .required(
          t("form.validate.required", {
            title: t(
              `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.field}`
            ),
          })
        )
        .max(
          REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.max,
          t("form.validate.char_max", {
            max: REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.max,
          })
        ),
    }),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      [COMMON_FIELD.PBAN.field]: "2.0.0",
      [COMMON_FIELD.MSO.field]: "06/ĐN-PSĐT",
      [COMMON_FIELD.NCQDTLAP.field]: [],
      [COMMON_FIELD.NGCCMND.field]: [],
      [COMMON_FIELD.NLAP.field]: [new Date()],
      [COMMON_FIELD.MST.field]: "",
      [COMMON_FIELD.TEN.field]:
        "Đề nghị cấp hóa đơn điện tử có mã theo từng lần phát sinh",
      [`${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.NHDONG.field}`]:
        [],
      [`${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.MST.field}`]:
        "",
    },
  });

  const submitForm = values => {
    const finalData = formatData(values);
    if (dataDetail.id) {
      dispatch(editRequestInvoiceCode(finalData, dataDetail.id));
    } else {
      dispatch(createRequestInvoiceCode(finalData));
    }
  };

  const formatRequestContentObj = data => {
    const objectData = {};
    for (const keyItem in data) {
      const dataChild = data[keyItem];
      // get From Date
      if (Array.isArray(dataChild)) {
        objectData[keyItem] = convertDate(dataChild[0]);
      } else if (typeof dataChild === "object" && dataChild !== null) {
        // get value from select
        objectData[keyItem] = dataChild.value;
      } else {
        // get value text
        objectData[keyItem] = dataChild;
      }
    }
    return objectData;
  };

  const formatData = values => {
    const finalData = {};
    //
    for (const key in values) {
      const data = values[key];
      if (key === REQUEST_CONTENT_OBJ_FIELD.field) {
        finalData[REQUEST_CONTENT_OBJ_FIELD.field] =
          formatRequestContentObj(data);
      } else {
        //get From Date
        if (Array.isArray(data)) {
          finalData[key] = convertDate(data[0]);
        } else if (typeof data === "object" && data !== null) {
          // get value from select
          finalData[key] = data.value;
        } else {
          // get value text
          finalData[key] = data;
        }
      }
    }
    delete finalData[
      `${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.NHDONG.field}`
    ];
    return finalData;
  };

  return (
    <Modal
      size="lg"
      contentClassName="detail-data-format"
      style={{ maxWidth: "95%" }}
      //   contentClassName="custom-modal-style"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          {t(`modal.title.${dataDetail?.mode}`)}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "74vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> {t("modal.title.basic")}</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {/* Phiên bản XML */}
                  {/* <Col>
                            <FormGroup className="mb-2">
                              {generateInputField(
                                t(`field.${COMMON_FIELD.PBAN.field}`),
                                true,
                                "text",
                                errors,
                                touchedFields,
                                COMMON_FIELD.PBAN.field,
                                t("placeholder.enter", {
                                  title: t(`field.${COMMON_FIELD.PBAN.field}`),
                                }),
                                register,
                                true
                              )}
                            </FormGroup>
                          </Col> */}
                  {/* Tên cơ quan thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TCQT.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TCQT.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TCQT.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>

                  {/* Tên đề nghị */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TEN.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TEN.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TEN.field}`),
                        }),
                        register,
                        true
                      )}
                    </FormGroup>
                  </Col>

                  {/* Mã CQT */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MCQT.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MCQT.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.MCQT.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Mẫu số đề nghị */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MSO.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MSO.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.MSO.field}`),
                        }),
                        register,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  {/* Tên tổ chức cá nhân */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TTCCNHAN.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TTCCNHAN.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TTCCNHAN.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ liên hệ*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DCLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DCLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DCLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ thư điện tử*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DCTDTU.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DCTDTU.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Điện thoại liên hệ*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DTLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DTLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DTLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Số quyết định thành lập*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.SQDTLAP.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.SQDTLAP.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.SQDTLAP.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày cấp quyết định thành lập */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateField(
                        t(`field.${COMMON_FIELD.NCQDTLAP.field}`),
                        "",
                        true,
                        errors,
                        COMMON_FIELD.NCQDTLAP.field,
                        "DD/MM/YYYY",
                        disableForm,
                        control,
                        optionDateLocale
                      )}
                    </FormGroup>
                  </Col>
                  {/* Cơ quan cấp quyết định thành lập*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.CQCQDTLAP.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.CQCQDTLAP.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.CQCQDTLAP.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>

                  {/* Mã số thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MST.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MST.field,
                        "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)",
                        register,
                        disableForm,
                        "",
                        control,
                        false,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  {/* Tên người nhận hóa đơn */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TNNHDON.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TNNHDON.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TNNHDON.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* CMND */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.CMND.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.CMND.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.CMND.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày cấp CMND */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateField(
                        t(`field.${COMMON_FIELD.NGCCMND.field}`),
                        "",
                        true,
                        errors,
                        COMMON_FIELD.NGCCMND.field,
                        "DD/MM/YYYY",
                        disableForm,
                        control,
                        optionDateLocale
                      )}
                    </FormGroup>
                  </Col>
                  {/* Nơi cấp CMND */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.NCCMND.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.NCCMND.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.NCCMND.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa danh */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DDANH.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DDANH.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DDANH.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày lập */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateField(
                        t(`field.${COMMON_FIELD.NLAP.field}`),
                        "",
                        true,
                        errors,
                        COMMON_FIELD.NLAP.field,
                        "DD/MM/YYYY",
                        true,
                        control,
                        optionDateLocale
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <div className="custom-form-heading mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> Nội dung đề nghị</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {/* Tên hàng hóa, dịch vụ, diễn giải*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.THHDVU.field}`
                        ),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.THHDVU.field,
                        t("placeholder.enter", {
                          title: t(
                            `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.THHDVU.field}`
                          ),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Tên */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.TEN.field}`
                        ),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.TEN.field,
                        t("placeholder.enter", {
                          title: t(
                            `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.TEN.field}`
                          ),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.DCHI.field}`
                        ),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.DCHI.field,
                        t("placeholder.enter", {
                          title: t(
                            `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.DCHI.field}`
                          ),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Mã số thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.MST.field}`
                        ),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.MST.field,
                        "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)",
                        register,
                        disableForm,
                        control,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  {/* Số hợp đồng */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.SHDONG.field}`
                        ),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.SHDONG.field,
                        t("placeholder.enter", {
                          title: t(
                            `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.SHDONG.field}`
                          ),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày hợp đồng */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.NHDONG.field}`
                        ),
                        "",
                        true,
                        errors,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.NHDONG.field,
                        "DD/MM/YYYY",
                        disableForm,
                        control,
                        optionDateLocale
                      )}
                    </FormGroup>
                  </Col>
                  {/* Doanh thu phát sinh*/}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputFieldObject(
                        t(
                          `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.field}`
                        ),
                        true,
                        "number",
                        errors,
                        touchedFields,
                        REQUEST_CONTENT_OBJ_FIELD.field,
                        REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.field,
                        t("placeholder.enter", {
                          title: t(
                            `field.${REQUEST_CONTENT_OBJ_FIELD.field}.${REQUEST_CONTENT_OBJ_FIELD.DTPSINHNM.field}`
                          ),
                        }),
                        register,
                        disableForm,
                        control,
                        false,
                        true
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </ModalBody>
            <ModalFooter>
              <React.Fragment>
                {(dataDetail?.mode === MODE_FORM.ADD ||
                  dataDetail?.mode === MODE_FORM.EDIT) && (
                  <Button
                    type="button"
                    color={
                      dataDetail?.mode === MODE_FORM.ADD ? "primary" : "success"
                    }
                    className="btn-label"
                    disabled={loadingSubmitCreate || loadingSubmitEdit}
                    onClick={handleSubmit(submitForm)}
                  >
                    <i className="fas fa-save label-icon"></i>
                    {t(`button.${dataDetail?.mode}`)}
                  </Button>
                )}
                {dataDetail?.mode === MODE_FORM.VIEW &&
                  detailRequestInvoiceCode?.resource_id && (
                    <Button
                      type="button"
                      color="primary"
                      className="btn-label"
                      onClick={() => {
                        dispatch(
                          downloadXmlRequestInvoiceCode(
                            detailRequestInvoiceCode?.resource_id,
                            detailRequestInvoiceCode?.ten
                          )
                        );
                      }}
                    >
                      <i className="bx bx-download label-icon"></i>
                      Download XML
                    </Button>
                  )}
                {detailRequestInvoiceCode?.auth_status === AUTH_STATUS_NEW &&
                  dataDetail?.mode === MODE_FORM.VIEW && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-label"
                      onClick={() => {
                        toggleReleaseModal();
                      }}
                    >
                      <i className="bx bx-send label-icon"></i>
                      Phát hành đề nghị
                    </Button>
                  )}
              </React.Fragment>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailData.propTypes = {
  toggleReleaseModal: PropTypes.func,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  i18n: PropTypes.any,
};

export default DetailData;
